/**
 * @Description Container for Actionable Text Input
 * @FileName index.js
 * @Author SAMAPTI TALUKDAR-talusam
 * @CreatedOn 23 March, 2021 01:31:24
 * @IssueID 720
 */

import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './scss/style.scss';
import { FasatChip, FasatTextInput, FasatActionButton } from '../../../components';

function ActionableTextInput({
  inlineButtonText,
  placeholder,
  errors,
  changeValues,
  type,
  values,
  label,
  ariaLabel,
}) {
  const [inputValue, setInputValue] = useState('');
  const [arr, setArr] = useState([]);

  useEffect(() => {
    if (values) {
      const castingValues = typeof values === 'string' ? values.split(',') : values;
      setArr(castingValues);
    } else {
      setArr([]);
    }
  }, [values]);

  /**
  * Constant values for classNames, placeholders, types
  */
  const actionableTextInput = 'actionableTextInput';
  const actionableTextInputWithLabel = 'actionableTextInputWithLabel';
  const inputId = 'id';
  const inputName = 'name';
  const selectedContainer = 'selectedContainer';
  const addLinkContainer = 'addLinkContainer';

  /**
  * @param {String} item Removes the selected item
  */
  const deleteItem = useCallback(
    (item) => {
      setArr((preArr) => {
        const filteredItem = preArr.filter((value) => item !== value);
        changeValues(filteredItem);
        return filteredItem;
      });
    },
    [arr, changeValues],
  );

  /**
  * Adds the entered textbox value as a chip
  */
  const addItem = useCallback(() => {
    // VALUE SPLIT WITH PIPE
    inputValue.split('|').forEach((initValue) => {
      const value = initValue.trim();
      if (value.length > 0 && arr.indexOf(value) < 0) {
        const arrClone = arr;
        arrClone.push(value);
        setArr(arrClone);
        setInputValue('');
        changeValues(arrClone);
      }
    });
  }, [changeValues, arr, inputValue]);
  const handleItemChanges = useCallback((event) => {
    const { value } = event.target;
    setInputValue(value);
  }, [setInputValue]);
  return (
    <div className={label ? actionableTextInputWithLabel : actionableTextInput}>
      <FasatTextInput
        errors={errors}
        id={inputId}
        name={inputName}
        value={inputValue}
        onChange={handleItemChanges}
        placeholder={placeholder}
        label={label}
        aria-label={ariaLabel}
        onInputEnabled={type === 'number'}
        inputNumWithPipe={type === 'number'}
      />
      <div className={addLinkContainer}>
        <FasatActionButton onClick={addItem}>{inlineButtonText}</FasatActionButton>
      </div>
      <div className={selectedContainer}>
        {arr && arr.map((si) => {
          const handleClick = (item) => (item ? () => deleteItem(item) : undefined);
          return <FasatChip key={si} data={si} onClick={handleClick(si)} />;
        })}

      </div>
    </div>
  );
}

ActionableTextInput.propTypes = {
  inlineButtonText: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  changeValues: PropTypes.func,
  errors: [
    {
      id: PropTypes.string,
      isError: PropTypes.bool,
      msg: PropTypes.string,
    },
  ],
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
};

ActionableTextInput.defaultProps = {
  inlineButtonText: '',
  placeholder: '',
  type: 'text',
  changeValues: () => undefined,
  errors: [
    {
      id: '',
      isError: false,
      msg: '',
    },
  ],
  label: '',
  ariaLabel: '',
};

export default ActionableTextInput;
